import type { ReactNode, Ref } from 'react'
import { TextInput, View, type TextInputProps } from 'react-native'

import { Typography } from '@/src/elements/text/Typography'
import { colors } from '@/src/styles/colors'

type TAuthInputProps = TextInputProps & {
  errorMessage?: ReactNode
  ref?: Ref<TextInput>
}

export const AuthInput = ({ errorMessage, testID, ...props }: TAuthInputProps): ReactNode => (
  <View>
    <TextInput
      {...props}
      testID={testID}
      className="text-xl font-bold font-nunito"
      placeholderTextColor={colors.default['text-contrast-high']['DEFAULT']}
      cursorColor={colors.default['text-contrast-high']['DEFAULT']}
      selectionColor={colors.default['text-contrast-high']['DEFAULT']}
      autoCorrect
    />
    {errorMessage != null && (
      <Typography testID={`${testID}-error-message`} colors="danger">
        {errorMessage}
      </Typography>
    )}
  </View>
)
